RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.DateRange = Marionette.ItemView.extend({
        ui: {
            startDate: 'input[name=startDate]',
            endDate: 'input[name=endDate]'
        },
        eventsNotToDebounce: {
            'focus @ui.startDate': 'onStartDateFocused',
            'focus @ui.endDate': 'onEndDateFocused',
            'change @ui.startDate': 'onStartDateChanged',
            'change @ui.endDate': 'onEndDateChanged'
        },
        tagName: 'form',
        format: 'MM/DD/YYYY',
        className: 'form-inline',
        attributes: {
            role: 'form'
        },
        template: '#shellDateRangeTemplate',
        templateHelpers: function () {

            const me = this;
            const model = me.model;
            const type = Marionette.getOption(me, 'type');
            const format = Marionette.getOption(me, 'format');

            const result = {
                startDate: model.get(`${type}PeriodStart`).format(format),
                endDate: model.get(`${type}PeriodEnd`).format(format)
            };

            return result;
        },
        onDateFocused: function (name) {

            const me = this;
            me.trigger('selected', name, me.getDate(name));
        },
        onStartDateFocused: function () {

            const me = this;
            me.onDateFocused('start');
        },
        onEndDateFocused: function () {

            const me = this;
            me.onDateFocused('end');
        },
        onDateChanged: function (name) {

            const me = this;
            const date = me.getDate(name);
            me.updateOppositeDate(name, date);
            me.trigger('selected', name, date);
        },
        onStartDateChanged: function () {

            const me = this;
            me.onDateChanged('start');
        },
        onEndDateChanged: function () {

            const me = this;
            me.onDateChanged('end');
        },
        getDate: function (name) {

            const me = this;
            const date = moment.utc(me.ui[`${name}Date`].val());
            return date;
        },
        setDate: function (name, date) {

            const me = this;
            const format = Marionette.getOption(me, 'format');
            const utcDate = moment.utc(date);

            me.ui[`${name}Date`].val(utcDate.format(format));

            me.updateOppositeDate(name, date);
        },
        getRange: function () {

            const me = this;
            const type = Marionette.getOption(me, 'type');

            const result = {};
            result[`${type}PeriodStart`] = me.ui.startDate.val();
            result[`${type}PeriodEnd`] = me.ui.endDate.val();

            return result;
        },
        updateOppositeDate: function (name, date) {

            const me = this;
            const utcDate = moment.utc(date);
            const oppositeName = (name === 'start' ? 'end' : 'start');
            const oppositeDate = moment.utc(me.ui[`${oppositeName}Date`].val());

            if (name === 'start' && utcDate.isAfter(oppositeDate)) {

                me.setDate(oppositeName, date);
            }
        },
        focusOppositeDate: function (name) {

            const me = this;
            me.ui[`${name === 'start' ? 'end' : 'start'}Date`].focus();
        }
    });

}, window.moment);
